// extracted by mini-css-extract-plugin
module.exports = {"earnedBadges":"styles_earnedBadges__10qae"};